/** Parámetros para la promesa simulada */
interface IResponse<T> {
  time?: number;
  resolveData?: T;
}

/**
 * Simula una promesa exitosa con datos configurables.
 * Útil para pruebas y desarrollo sin llamadas reales a la API.
 */
const successPromiseWithData = async <T = { success: true }>(
  params: IResponse<T> = {}
): Promise<IResponse<T>> => {
  const { time = 10000, resolveData } = params;

  return new Promise<IResponse<T>>(resolve => {
    setTimeout(() => {
      resolve({ time, resolveData });
    }, time);
  });
};

export { successPromiseWithData };
export type { IResponse };
